// extracted by mini-css-extract-plugin
export var container = "istNMiaO";
export var containerColorLime = "OWbjEXJI";
export var containerColorCactus = "xF62BGPJ";
export var containerColorRed = "l86hwf-W";
export var containerColorYellow = "_5JDUXYJs";
export var containerColorDisabled = "-6PaIalJ";
export var containerColorWhite = "lLzZJfT3";
export var containerColorGray = "wmQIoBTp";
export var containerColorDarkviolet = "C4xz2KGf";
export var containerColorCharcoal = "UMJN+YjI";
export var containerTypeMaterial = "TpXw-FOg";